import React, { Component } from 'react'
import './HomePlateform.css'
import { globals } from '../Globals/Globals'

class HomeFooter extends Component{
    constructor(props){
        super(props)
    }

    render = () => {
        return(
            <div id="home-footer">
                  <div id="footer-top">
                  </div>
        
                  <div id="footer-bottom">
                    <div id="social-networks">
                      <div onClick={()=>{window.open(globals.links.linked_in)}} id='linked-in'/>
                      <div onClick={()=>{window.open(globals.links.facebook)}} id='facebook'/>
                      <div onClick={()=>{window.open(globals.links.youtube)}} id='youtube'/>
                      <div onClick={()=>{window.open(globals.links.le_cercle)}} id='le_cercle'/>
                      <a id='telephone' href="tel:+33 (0) 805 69 51 51"></a>
                    </div>
                    <div id="footer-copyrights">
                      © 2025 By Le Cercle
                      <a
                        id="pmc-powered"
                        href="https://patrickm.consulting"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="PMC powered"
                      >
                        <svg className="pmc-logo" viewBox="0 0 199 145" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                          <g fill="currentColor">
                            <polygon points="0,72.5 51,24 66,41 40,72.5 66,104 51,121"/>
                            <rect x="90" y="0" width="19" height="145" transform="rotate(20 99.5 72.5)"/>
                            <polygon points="199,72.5 148,24 133,41 159,72.5 133,104 148,121"/>
                          </g>
                        </svg>
                        <span className="pmc-text">pmc powered</span>
                      </a>
                    </div>
                  </div>
            </div>
        )
    }
} 

export default HomeFooter;